import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AdminAuthService } from '../../service/admin-auth.service';

@Component({
  selector: 'app-logout',
  standalone: true,
  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.css'
})
export class LogoutComponent {
  constructor(private router: Router, private authService: AdminAuthService) { }
  ngOnInit() {
    this.authService.logout();
    this.router.navigate(['/admin/home']);
  }

}
